interface FormatNameOptions {
  /**
   * Whether to trim only the start of the string or both start and end
   * @default 'both'
   */
  trimMode?: "start" | "both";
}

export function formatName(input: string, options?: FormatNameOptions): string {
  const trimMode = options?.trimMode ?? "both";
  const trimmedInput = trimMode === "start" ? input.trimStart() : input.trim();

  if (trimmedInput.length === 0) {
    return trimmedInput;
  }

  return trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1);
}
